import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL + '/api';

const ProtectedRoute = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isAuthenticated, setIsAuthenticated] = useState(
    location.state?.user ? true : null
  );
  const [user, setUser] = useState(location.state?.user || null);

  useEffect(() => {
    if (location.state?.user) {
      return;
    }

    const checkAuth = async () => {
      // Try cookie-based auth first
      try {
        const response = await axios.get(`${API_URL}/auth/me`, {
          withCredentials: true,
        });
        setIsAuthenticated(true);
        setUser(response.data);
        return;
      } catch (cookieError) {
        // Cookie auth failed, try localStorage token
      }

      // Fallback: try localStorage token
      const token = localStorage.getItem('session_token') || 
                    localStorage.getItem('token') || 
                    localStorage.getItem('socyy_token');
      
      if (token) {
        try {
          const response = await axios.get(`${API_URL}/auth/me`, {
            headers: { Authorization: `Bearer ${token}` }
          });
          setIsAuthenticated(true);
          setUser(response.data);
          return;
        } catch (tokenError) {
          // Token also invalid, clear it
          localStorage.removeItem('session_token');
          localStorage.removeItem('token');
          localStorage.removeItem('socyy_token');
        }
      }

      // Both auth methods failed
      setIsAuthenticated(false);
      navigate('/login', { replace: true });
    };

    checkAuth();
  }, [navigate, location.state]);

  if (isAuthenticated === null) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary"></div>
      </div>
    );
  }

  if (isAuthenticated) {
    return React.cloneElement(children, { user });
  }

  return null;
};

export default ProtectedRoute;
